import styled, { css } from 'styled-components';
import SVG from 'react-inlinesvg';
import { Link } from '@perch-labs/shrike';

const hoverStyles = css`
  && {
    path {
      stroke: ${props => props.theme.colors.content.primary};
      fill: ${props => props.theme.colors.content.primary};
    }
    circle {
      stroke: ${props => props.theme.colors.content.primary};
    }
  }
`;

export const ImageLink = styled(Link).attrs({
  hideIcon: true,
})<StyleProps>`
  position: relative;
  display: flex;
  max-width: 400px;
  width: 100%;

  img {
    width: 100%;
  }

  &:hover {
    ${hoverStyles}
  }

  padding-left: 2px;
  padding-right: 2px;
`;

export const PlaySVG = styled(SVG)`
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -7% 0 0 -7%;
  && {
    path {
      stroke: white;
      fill: white;
    }
    circle {
      stroke: white;
    }
  }
`;

export const TextLink = styled(Link).attrs({
  hideIcon: true,
})<StyleProps>`
  color: ${props => props.theme.colors.content.accent9};
  display: block;
  max-width: 400px;
  width: 100%;

  &:hover {
    ${hoverStyles}
  }

  &:focus {
    padding-left: 0;
    padding-right: 0;
  }
`;
